import { Link } from "react-router-dom";
import { categoryShowcaseItems } from "@/mocks/collections";

const categoryToParam: Record<string, string> = {
  Living: "living",
  Bedroom: "bedroom",
  Dining: "dining",
  "Custom Orders": "custom-orders",
  "Signature Pieces": "signature-pieces",
};

export default function FeaturedCollections() {
  return (
    <section className="bg-brand-brown py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-display text-brand-gold text-xs tracking-[4px] uppercase block mb-4">Browse Our Work</span>
          <h2 className="font-serif text-4xl md:text-5xl text-brand-cream font-bold">
            Our <em className="text-brand-goldlight">Collections</em>
          </h2>
          <p className="font-sans text-brand-cream/60 mt-4 max-w-xl mx-auto text-sm leading-relaxed">
            Timeless pieces for every space. Each collection reflects our 150-year commitment to handcrafted excellence.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {categoryShowcaseItems.map((col) => (
            <Link
              key={col.id}
              to={`/collections?category=${categoryToParam[col.category] || "all"}`}
              className="group relative overflow-hidden rounded-lg cursor-pointer block"
              data-product-shop
            >
              {/* Image */}
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={col.image}
                  alt={col.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-brand-darkbrown/90 via-brand-darkbrown/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-400" />

              {/* Category Badge */}
              <div className="absolute top-4 right-4 bg-brand-gold/90 text-brand-darkbrown font-display text-[10px] tracking-widest uppercase px-3 py-1 rounded-full">
                {col.category}
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-400">
                <p className="font-display text-brand-gold text-[10px] tracking-widest uppercase mb-1">{col.category}</p>
                <h3 className="font-serif text-base text-brand-cream font-bold mb-2">{col.category === "Custom Orders" ? "Custom Orders" : col.category === "Signature Pieces" ? "Signature Pieces" : col.name}</h3>
                <span className="whitespace-nowrap inline-flex items-center gap-2 font-display text-xs tracking-widest uppercase text-brand-gold hover:gap-3 transition-all duration-300 cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity">
                  View Designs <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-12">
          <Link
            to="/collections"
            className="whitespace-nowrap inline-block font-display text-sm tracking-widest uppercase px-12 py-4 bg-transparent border-[1.5px] border-brand-gold text-brand-gold rounded-full hover:bg-brand-gold hover:text-brand-darkbrown transition-all duration-300 cursor-pointer"
          >
            View All Collections
          </Link>
        </div>
      </div>
    </section>
  );
}
